<template>
  <v-card class="pa-0 ma-0 zIndex10 d-flex flex-column fill-height">
    <v-card-item>
      <v-card-title>File {{ props.activeFile.name }} </v-card-title>
      <v-card-subtitle>{{ props.activeFile.mimetype }} - {{ sizeInBytesToHumanreadable(props.activeFile?.size) }}<br>
        state: {{ props.activeFile?.state || "-" }} | purpose: {{ props.activeFile?.purpose || "-" }}
        <!-- {{ props.activeFile.size }} Bytes -->
      </v-card-subtitle>
    </v-card-item>
    <v-divider class="" />

    <v-card-text class="d-flex flex-row flex-grow-0">

      <template v-if="!isFormReadOnly?.value && !props.connect_uuid">

        <v-dialog width="auto" v-if="props.current_uuid">
          <template v-slot:activator="{ props }">
            <v-btn v-if="activeFile.target_uuid" v-bind="props" color="orange-darken-3" class="mr-2"
                size="">
              <v-icon size="x-large" class="ma-3">mdi-link-off</v-icon>
            </v-btn>
          </template>
          <template v-slot:default="{ isActive }">
            <v-card theme="dark" class="ma-5">
              <v-card-item>
                <v-card-title>Scollega</v-card-title>
              </v-card-item>
              <v-card-text class="">
                <p>
                  Scollega il file dall'oggetto corrente.<br>
                  Rimarrà nella lista dei media acquisiti.
                </p>
              </v-card-text>
              <v-card-actions class="flex-column ">
                <!-- <v-btn  variant="flat" size="large" color="success" @click="applyColor(); isActive.value = false">
                            <v-icon class="mr-2">mdi-content-save</v-icon>
                            Applica</v-btn><br> -->

                <v-btn @click="unlinkFileFromCurrentObject(); isActive.value = false" size="large"
                    color="orange-darken-3" class="ma-2" variant="elevated">
                  <v-icon>mdi-link-off</v-icon> conferma
                </v-btn>
                <v-btn variant="outlined" size="large" color="white" @click="isActive.value = false"
                    class="ma-2">
                  <v-icon>mdi-chevron-down</v-icon>
                  Indietro
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>

        <template v-if="props.activeFile?.state === 201">
          <v-btn readonly color="green-darken-3" class="mr-2" size="">
            <v-icon size="x-large" class="ma-3">mdi-cloud-check</v-icon>
          </v-btn>

          <!-- <v-btn @click="switchUploaded(null)" color="yellow-darken-3" class="mr-2" size="">
            <v-icon size="x-large" class="ma-3">mdi-cloud-cancel-outline</v-icon>
          </v-btn> -->
        </template>
        <!-- <template v-else>
          <v-btn @click="switchUploaded(201)" color="yellow-darken-3" class="mr-2" size="">
            <v-icon size="x-large" class="ma-3">mdi-cloud-cancel-outline</v-icon>
          </v-btn>
        </template> -->
        <!-- <template v-if="props.activeFile?.target_uuid == props.current_uuid || !props.activeFile?.target_uuid"> -->

        <v-dialog width="auto">
          <template v-slot:activator="{ props }">
            <v-btn v-bind="props" color="red-darken-3" class="mr-2" size="">
              <v-icon size="x-large" class="ma-3">mdi-delete</v-icon>
            </v-btn>
          </template>
          <template v-slot:default="{ isActive }">
            <v-card theme="dark" class="ma-5">
              <v-card-item>
                <v-card-title>Elimina</v-card-title>
              </v-card-item>
              <v-card-text class="">
                <div v-if="props.activeFile?.state !== 201 && ['image','audio','video',].includes(filetype)" >
                  <p>
                    <v-icon color="orange">mdi-alert</v-icon>
                    Attenzione, il file non è ancora stato caricato sul server
                  </p>
                  <p v-if="props.activeFile?.target_uuid === props.current_uuid">
                    <v-icon color="orange">mdi-alert</v-icon>
                    Attenzione, il file è collegato all'oggetto corrente
                  </p>
                  <p v-else-if="props.activeFile?.target_uuid">
                    <v-icon color="orange">mdi-alert</v-icon>
                    Attenzione, il file è collegato ad un oggetto
                  </p>
                </div>
                  <p class="mt-4">
                    Stai per eliminare definitivamente il file
                  </p>
                <!-- <pre>{{ JSON.stringify(file, null, 4).replaceAll("-", "-\n        ") }}</pre> -->
              </v-card-text>
              <v-card-actions class="flex-column ">
                <!-- <v-btn  variant="flat" size="large" color="success" @click="applyColor(); isActive.value = false">
                            <v-icon class="mr-2">mdi-content-save</v-icon>
                            Applica</v-btn><br> -->

                <v-btn @click="deleteFile(); isActive.value = false" size="large" color="red" class="ma-2"
                    variant="elevated">
                  <v-icon>mdi-delete</v-icon> conferma
                </v-btn>
                <v-btn variant="outlined" size="large" color="white" @click="isActive.value = false"
                    class="ma-2">
                  <v-icon>mdi-chevron-down</v-icon>
                  Indietro</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </template>


      <v-spacer />

      <v-btn v-if="sharingSupported" @click="shareFile(props.activeFile)" color="blue-darken-3" size="">
        <v-icon size="x-large" class="ma-3">mdi-share-variant</v-icon>
      </v-btn>
      <v-btn @click="downloadFile(props.activeFile)" download color="blue-darken-3" class="ml-3" size="">
        <v-icon size="x-large" class="ma-3">mdi-file-download</v-icon>
      </v-btn>

      <template v-if="props.activeFile.target_uuid && !props.current_uuid">
        <v-btn :to="`/map/?uuid=${props.activeFile.target_uuid}`" color="blue-darken-3" class="ml-3"
            size="">
          <v-icon size="x-large" class="ma-3">mdi-map-search</v-icon>
        </v-btn>
      </template>

    </v-card-text>

    <v-card-text 
    id="media_container" 
    class="d-flex flex-column  flex-grow-1 justify-center align-center"
    
    v-touch="{
      left: () => emitSwipe('Left'),
      right: () => emitSwipe('Right'),
      up: () => emitSwipe('Up'),
      down: () => emitSwipe('Down')
    }"
    >

      <!-- 
      <slot name="prepend">
      </slot> -->

      <div id="the_video_container" v-if="filetype === 'video'">
        <video v-if="content" controls id="the_video" :src="content" :type="props.activeFile.mimetype">
          Your browser does not support the video element.
        </video>
      </div>

      <!-- <div id="the_audio_container" v-if="type === 'audio'"  class="d-flex flex-column" > -->
      <audio v-if="filetype === 'audio' && content" controls id="the_audio">
        <source :src="content" :type="props.activeFile.mimetype" />
        Your browser does not support the audio element.
      </audio>
      <!-- </div> -->

      <img id="the_image" v-if="filetype === 'image'" :src="content" />


      <p v-if="!(['audio', 'video', 'image',].includes(filetype))">mimetype <br>{{ filetype }}<br>non supportato dal visualizzatore</p>


      <!-- 
      <slot name="append">
      </slot> -->

    </v-card-text>
    <v-card-text v-if="props.connect_uuid" class="text-center flex-grow-0">

      <p v-if="props.connect_uuid" class="text-center">
        <v-btn color="orange-darken-3" prepend-icon="mdi-link" @click="linkFileToCurrentObject"
            class="my-2">Collega all'oggetto corrente</v-btn>
      </p>

    </v-card-text>
    <v-card-actions class="flex-row justify-space-between align-center bg-grey-darken-4">
      <slot name="actions">
      </slot>
    </v-card-actions>
  </v-card>
</template>

<script setup>

import { ref, toRefs, watch, computed, onMounted, inject } from "vue";

import { useFilesStore } from "@/store/files";

const isFormReadOnly = ref(false) 
const svf = inject(Symbol.for("vuetify:form"), { isReadonly: false })
isFormReadOnly.value = svf.isReadonly.value

const props = defineProps({
  activeFile: {
    type: Object,
    required: true
  },
  current_uuid: {
    type: String,
    default: null
  },
  connect_uuid: {
    type: String,
    default: null
  },
})

const { activeFile } = toRefs(props)


const emit = defineEmits(['onFileDeleted', 'onFileLinkedChanged', 'swipe'])


const emitFileDeleted = (name) => {
  emit('onFileDeleted', name)
}

const emitFileLinkedChanged = (name) => {
  emit('onFileLinkedChanged', name)
}
const emitSwipe = (direction) => {
  emit('swipe', direction)
}

const filesStore = useFilesStore();


const filetype = computed(() => {
  if (["audio/mp3", "audio/mpeg", "audio/ogg", "audio/m4a", "audio/x-m4a"].includes(props.activeFile.mimetype)) {
    return "audio"
  }
  if (["video/mp4", "video/webm"].includes(props.activeFile.mimetype)) {
    return "video"
  }
  if (["image/jpg", "image/jpeg", "image/png", "image/gif"].includes(props.activeFile.mimetype)) {
    return "image"
  }
  return props.activeFile.mimetype
})




const content = ref(null)

const updateContentValue = async (file) => {
  const completeFile = await filesStore.get(file.id)
  content.value = completeFile.content
}

watch(activeFile, async (newFile) => {
  updateContentValue(newFile)
})

onMounted(async () => {




  updateContentValue(activeFile.value)
  console.log(props.activeFile)
})


const downloadFile = async () => {
  const downloadLink = document.createElement("a");
  downloadLink.download = props.activeFile.name;
  downloadLink.innerHTML = "Download File";
  downloadLink.href = content.value;
  downloadLink.click();
  downloadLink.remove();
}


const sharingSupported = computed(() => {
  return "share" in navigator
})


const shareFile = async () => {

  console.log('✋ sharing');

  const blob = await (await fetch(content.value)).blob();
  const file = new File([blob], props.activeFile.name, { type: blob.type })

  navigator.share({
    title: props.activeFile.name,
    text: props.activeFile.name,
    files: [file],
  })
}


const deleteFile = async () => {
  // console.log("deleting", props.activeFile)
  await filesStore.del(props.activeFile.id)
  emitFileDeleted(props.activeFile.name)
}

const linkFileToCurrentObject = async () => {
  await filesStore.updatedSomeValues(props.activeFile.id, {
    target_uuid: props.connect_uuid,
    purpose: "media"
  })
  emitFileLinkedChanged(props.activeFile.name)
}

const unlinkFileFromCurrentObject = async () => {
  await filesStore.updatedSomeValues(props.activeFile.id, {
    target_uuid: null,
    purpose: null
  })
  emitFileLinkedChanged(props.activeFile.name)
}

// const switchUploaded = async (newState) => {
//   if (confirm("switch stato"))
//   await filesStore.updatedSomeValues(props.activeFile.id, {
//     state: newState
//   })
//   emitFileLinkedChanged(props.activeFile.name)

// }




const sizeInBytesToHumanreadable = (size) => {

  if (!size) return "? KB"

  size = parseFloat(size)

  if (size < 1024) {
    return size + " B"
  }
  if (size < 1024 * 1024) {
    return Math.round(size / 1024) + " KB"
  }
  if (size < 1024 * 1024 * 1024) {
    return Math.round(size / 1024 / 1024) + " MB"
  }
  return Math.round(size / 1024 / 1024 / 1024) + " GB"

}
</script>

<style scoped>
.zIndex10 {
  z-index: 10;
}

#media_container {
  min-height: 0;
}

#the_image {

  object-fit: contain;
  height: 100%;
  max-width: 100%
    /* height: 100%; */
}

#the_video_container {
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  height: 100%;
  overflow: hidden;
  text-align: center;
}

#the_video {
  object-fit: fill;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  /* Setting width & height to auto prevents the browser from stretching or squishing the video */
  /* width: auto;
  height: auto; */
}

/* 
#the_audio_container {
  height: 100%;
  width: 100%;
} */

#the_audio {
  width: 100%
}
</style>
